import React from 'react';
import {Button} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

// the colorwhite prop indicates the color of the button. if it is true the button is white else it is blue
const usePrimaryStyles = makeStyles({
  btnStyle:{
    color: props => (props.colorwhite ? '#153BAB':'white'),
    backgroundColor: props => (props.colorwhite ? 'white':'#153BAB'),
    borderRadius: '30px',
    boxShadow: props => (props.colorwhite ?'1.5px 2px 1.5px rgb(229,229,229)':'0'),
    width:props =>(props.width),
    fontFamily:['Nunito'].join(','),
    '&:hover': {
      backgroundColor: props => (props.colorwhite ? '#EAEAEA':'#1F3881')
    },
     textTransform: 'none',
     marginBottom:'0.5rem',
     fontSize: props =>(props.fntSize)
  },
});

const useSecondaryStyles = makeStyles({
  btnStyle:{
    color: props => (props.colorwhite ? '#e98030':'white'),
    backgroundColor: props => (props.colorwhite ? 'white':'#e98030'),
    borderRadius: '30px',
    boxShadow: props => (props.colorwhite ?'1.5px 2px 1.5px rgb(229,229,229)':'0'),
    width:props =>(props.width),
    fontFamily:['Nunito'].join(','),
    '&:hover': {
      backgroundColor: props => (props.colorwhite ? '#EAEAEA':'#e98050')
    },
     textTransform: 'none',
     marginBottom:'0.5rem',
     fontSize: props =>(props.fntSize)
  },
});

const CustomBtn = (props) =>{
  const Pclasses = usePrimaryStyles(props);
  const Sclasses = useSecondaryStyles(props);
  
  if (props.type === "secondary"){
    return <Button className={Sclasses.btnStyle} onClick={props.onClick}>{props.txt}</Button>
  }else{
    return <Button className={Pclasses.btnStyle} onClick={props.onClick}>{props.txt}</Button>
  }

}
export default CustomBtn;
